import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const doctorService = {
  async getDoctors() {
    try {
      const response = await axios.get(`${API_URL}/doctors`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getDoctorById(id) {
    try {
      const response = await axios.get(`${API_URL}/doctors/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createDoctor(doctorData) {
    try {
      const response = await axios.post(`${API_URL}/doctors`, doctorData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async updateDoctor(id, doctorData) {
    try {
      const response = await axios.put(
        `${API_URL}/doctors/${id}`,
        doctorData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deleteDoctor(id) {
    try {
      const response = await axios.delete(`${API_URL}/doctors/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default doctorService;
